import { render, staticRenderFns } from "./KeyValueInput.vue?vue&type=template&id=1a981bfc&"
import script from "./KeyValueInput.vue?vue&type=script&lang=js&"
export * from "./KeyValueInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a981bfc')) {
      api.createRecord('1a981bfc', component.options)
    } else {
      api.reload('1a981bfc', component.options)
    }
    module.hot.accept("./KeyValueInput.vue?vue&type=template&id=1a981bfc&", function () {
      api.rerender('1a981bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inputs/KeyValueInput.vue"
export default component.exports